import React, { useContext } from "react";
import { ConfigContext, CurrentContext } from "../../App";
import ColorCircle from "../elements/ColorCircle";
import SaveDialog from "../SaveDialog";
import ShareLink from "../ShareLink";
import TotalPrice from "../TotalPrice";

import logo from "../../vanchanger_logo_nebelblau.svg";
import SendConfigDialog from "src/components/SendConfigDialog";
import Pdf from "src/components/Pdf";

function Overview() {
    const current = useContext( CurrentContext );
    const config = useContext( ConfigContext );

    const outsideConfig = config.car.car
                                .filter( c => c.length === current.length )
                                .filter( c => c.engine === current.engine )
                                .filter( c => c.transmission === current.transmission )[0];

    const outerColor = config.carColorOutside.find( c => c.name === current.outside_color )!;
    const innerColor = config.colorInside.find( c => c.fabricColorName === current.inside_color )!;
    const innerVersion = config.inside.versions.find( v => v.name === current.inside_version )!;

    return <div className="flex configuration-part active">
        <div className="flex configuration-part-headline">
            <img className="part-headline-img"
                 src={logo}
                 alt="logo" />
            <h2>Übersicht</h2>
        </div>


        <div className="config-summary">

            <h3>Fahrzeug</h3>

            <dl>
                <dt>Fahrzeuglänge</dt>
                <dd>{current.length}</dd>
                <dt>Fahrzeugdetails</dt>
                <dd>
                    <ul className={"overview-enumeration"}>
                        {outsideConfig.info.map( i => <li key={i}>{i}</li> )}
                    </ul>
                </dd>
                <dt>Grundausstattung: {current.package}</dt>
                <dd>
                    <ul className={"overview-enumeration"}>
                        {config.carPackage.find( p => p.package === current.package )
                               ?.info.map( i => <li key={i.item}>{i.item}</li> )}
                    </ul>
                </dd>
                <dt>Außenfarbe</dt>
                <dd><ColorCircle color={outerColor.colorCode} /> {outerColor.name}</dd>
            </dl>

            <hr className={"summary-hr"} />

            <h3>Innenraum</h3>

            <dl>
                <dt>Innenausstattung</dt>
                <dd>{current.inside_version}</dd>
                <dt>Innenraumfarbe</dt>
                <dd>Polster: <ColorCircle color={innerColor.fabricColorCode} /> {innerColor.fabricColorName}</dd>
                <dd>Module: <ColorCircle color={innerColor.modulColorCode} /> {innerColor.modulColor}</dd>
                <dt>Sitzanzahl</dt>
                <dd>{current.seats}</dd>
                {/*<dd>{current.seats} (davon {innerVersion.includedSeats} inklusive)</dd>*/}
            </dl>

            <hr className={"summary-hr"} />

            <h3>Technik</h3>

            <dl>
                <dt>Technikpaket: {current.tech_package}</dt>
                <dd>
                    <ul className={"overview-enumeration"}>
                        {config.tech.techPackage.find( p => p.name === current.tech_package )
                               ?.info.map( i => <li key={i.item}>{i.item}</li> )}
                    </ul>
                </dd>
                {current.tech_optional.length !== 0 && <>
                    <dt>Optionale Features</dt>
                    <dd>
                        <ul className={"overview-enumeration"}>
                            {current.tech_optional.map( ( i: string ) => <li key={i}>{i}</li> )}
                        </ul>
                    </dd>
                </>}
                {current.tech_optional.length === 0 && <>
                    <i>Keine optionalen Features ausgewählt.</i>
                </>}
            </dl>

            <hr className={"summary-hr"} />

            <h3>Gadgets</h3>

            {current.gadgets.length === 0 ? <dl>
                <i>Keine Gadgets ausgewählt.</i>
            </dl> : <dl>
                <dt>Zusätzliche Gadgets</dt>
                <dd>
                    <ul className={"overview-enumeration"}>
                        {current.gadgets.map( ( i: string ) => <li key={i}>{i}</li> )}
                    </ul>
                </dd>
            </dl>}

            <hr className={"summary-hr"} />

            <h3>Konfiguration anfragen?</h3>

            {/*<ShareLink />*/}

            <p>Schick deine Anfrage noch heute ab und lade direkt im Anschluss ganz unverbindlich dein individuelles Angebot herunter.
                Um dir einen bestmöglichen Service zu bieten, melden wir uns bei Dir innerhalb der nächsten zwei Werktage.</p>

            {/*<SaveDialog />*/}
            {/*<SendConfigDialog />*/}

            <Pdf/>

        </div>


    </div>;
}

export default Overview;
